import { FC } from "react";
import { RouterProvider } from "react-router";
import * as Sentry from '@sentry/react';
 
import router from "./Routes";
import VercelAnalytics from "./components/VercelAnalytics";
import VercelSpeedInsights from "./components/VercelSpeedInsights";

import "./assets/css/style.css";

const FallbackComponent = () => <div>An error occurred. Try refreshing the page.</div>;

const App: FC = () => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
      <>
        <RouterProvider router={router} />
        <VercelAnalytics />
        <VercelSpeedInsights />
      </>
    </Sentry.ErrorBoundary>
  );
}

export default App;
